import { render, staticRenderFns } from "./BillRetrospectAll.vue?vue&type=template&id=32ba3da0"
import script from "./BillRetrospectAll.vue?vue&type=script&lang=js"
export * from "./BillRetrospectAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports